<template>
  <PageSeoData
    :title="
      $t('page_seo_data.app.title')
    "
    :description="
      $t('page_seo_data.app.description')
    "
  />
  <OurApps />
</template>

<script setup lang="ts">
import OurApps from "~/components/sections/OurApps.vue";
import PageSeoData from "~/components/pageSeoData/PageSeoData.vue";
</script>
